import { globalState } from '@codeleap/store'
import { LessonStore } from '../types'

const store = globalState<LessonStore>({})

export function set(params: Partial<LessonStore>) {
  store.set(params)
}

export function get<K extends keyof LessonStore>(key?: K): LessonStore | LessonStore[K] {
  return key ? store.get()[key] : store.get()
}

export function use(): LessonStore
export function use<T>(selector: (state: LessonStore) => T): T
export function use<T>(selector?: (state: LessonStore) => T) {
  return store.use(selector as any)
}
